import type { ThirdPartySummary } from '@/api/cms/thirdPartySummaries';

export const findAvailableModal =
  (modalIds: string[] | string) => (summaries: ThirdPartySummary[]) => {
    const modalIdArray = Array.isArray(modalIds) ? modalIds : [modalIds];
    const foundModal = modalIdArray.find(
      (level) => !summaries.map(({ modalId }) => modalId).includes(level)
    );
    return foundModal || undefined;
  };
